/**
 * 戦果関連任務
 * @static
 * @memberof Const
 */
export const RANKING_POINT_QUESTS = [
  {
    id: 'Bq2',
    name: '戦果拡張任務！「Z作戦」前段作戦',
    type: 'Quarterly',
    requires: [
      { area: '2-4', rank: 'A' },
      { area: '6-1', rank: 'A' },
      { area: '6-3', rank: 'A' },
      { area: '6-4', rank: 'S' },
    ],
    fuel: 0,
    ammo: 2000,
    steel: 0,
    bauxite: 0,
    rankingPoint: 350,
  },
  {
    id: 'Bq7',
    name: '新編成「三川艦隊」、鉄底海峡に突入せよ！',
    type: 'Quarterly',
    requires: [
      { area: '5-1', rank: 'S' },
      { area: '5-3', rank: 'S' },
      { area: '5-4', rank: 'S' },
    ],
    fuel: 800,
    ammo: 800,
    steel: 800,
    bauxite: 800,
    rankingPoint: 200,
  },
  {
    id: 'Bq8',
    name: '泊地周辺海域の安全確保を徹底せよ！',
    type: 'Quarterly',
    requires: [
      { area: '1-5', rank: 'S' },
      { area: '1-5', rank: 'S' },
      { area: '1-5', rank: 'S' },
      { area: '7-1', rank: 'S' },
      { area: '7-1', rank: 'S' },
      { area: '7-1', rank: 'S' },
      { area: '7-2-1', rank: 'S' },
      { area: '7-2-1', rank: 'S' },
      { area: '7-2-1', rank: 'S' },
      { area: '7-2-2', rank: 'S' },
      { area: '7-2-2', rank: 'S' },
      { area: '7-2-2', rank: 'S' },
    ],
    fuel: 2000,
    ammo: 500,
    steel: 0,
    bauxite: 500,
    rankingPoint: 300,
  },
  {
    id: 'Bq10',
    name: '戦果拡張任務！「Z作戦」後段作戦',
    type: 'Quarterly',
    requires: [
      { area: '7-2-2', rank: 'S' },
      { area: '5-5', rank: 'S' },
      { area: '6-2', rank: 'S' },
      { area: '6-5', rank: 'S' },
    ],
    fuel: 0,
    ammo: 0,
    steel: 2000,
    bauxite: 2000,
    rankingPoint: 400,
  },
  {
    id: 'Bq11',
    name: '南西諸島方面「海上警備行動」発令！',
    type: 'Quarterly',
    requires: [
      { area: '1-4', rank: 'S' },
      { area: '2-1', rank: 'S' },
      { area: '2-2', rank: 'S' },
      { area: '2-3', rank: 'S' },
    ],
    fuel: 0,
    ammo: 800,
    steel: 800,
    bauxite: 0,
    rankingPoint: 80,
  },
  {
    id: 'Bq12',
    name: '発令！「西方海域作戦」',
    type: 'Quarterly',
    requires: [
      { area: '4-1', rank: 'S' },
      { area: '4-2', rank: 'S' },
      { area: '4-3', rank: 'S' },
      { area: '4-4', rank: 'S' },
      { area: '4-5', rank: 'S' },
    ],
    fuel: 0,
    ammo: 0,
    steel: 2400,
    bauxite: 0,
    rankingPoint: 330,
  },
  {
    id: 'Bq13',
    name: '拡張「六水戦」、最前線へ！',
    type: 'Quarterly',
    requires: [
      { area: '5-1', rank: 'S' },
      { area: '5-4', rank: 'S' },
      { area: '6-4', rank: 'S' },
      { area: '6-5', rank: 'S' },
    ],
    fuel: 0,
    ammo: 1000,
    steel: 1000,
    bauxite: 1000,
    rankingPoint: 390,
  },
  {
    id: 'By9',
    name: 'AL作戦',
    type: 'Yearly',
    resetMonth: 6,
    requires: [
      { area: '3-1', rank: 'S' },
      { area: '3-3', rank: 'S' },
      { area: '3-4', rank: 'S' },
      { area: '3-5', rank: 'S' },
    ],
    fuel: 880,
    ammo: 880,
    steel: 880,
    bauxite: 880,
    rankingPoint: 480,
  },
  {
    id: 'By10',
    name: '機動部隊決戦',
    type: 'Yearly',
    resetMonth: 6,
    requires: [
      { area: '5-2', rank: 'S' },
      { area: '5-2', rank: 'S' },
      { area: '5-5', rank: 'S' },
      { area: '5-5', rank: 'S' },
      { area: '6-5', rank: 'S' },
      { area: '6-5', rank: 'S' },
      { area: '6-4', rank: 'A' },
      { area: '6-4', rank: 'A' },
    ],
    fuel: 1300,
    ammo: 1300,
    steel: 0,
    bauxite: 1300,
    rankingPoint: 600,
  },
  {
    id: 'B170',
    name: '改装特務空母「Gambier Bay Mk II」抜錨！',
    type: 'Once',
    requires: [
      { area: '2-4', rank: 'S' },
      { area: '2-4', rank: 'S' },
      { area: '3-5', rank: 'S' },
      { area: '3-5', rank: 'S' },
      { area: '6-4', rank: 'A' },
      { area: '6-4', rank: 'A' },
    ],
    fuel: 730,
    ammo: 730,
    steel: 730,
    bauxite: 730,
    rankingPoint: 800,
  },
];

export type RankingPointQuest = typeof RANKING_POINT_QUESTS[number];
